import { GlobalContext } from 'contexts/Global'
import { useHistory } from 'react-router-dom'
import React from 'react'
import { getParams } from 'utils/helpers'

export const useSurvey = () => {
	const [surveyTip, setSurveyTip] = React.useState(false)
	const history = useHistory()

	const {
		isGlobalLoading,
		isCampaignExpired,
		setGlobalLoading,
		setGlobalError,
		hasGlobalError,
		companySurvey,
		setCompanySurvey,
		showPrivacySettings,
	} = React.useContext<any>(GlobalContext)

	const { campaignAnswerSessions, campaign, employee } = companySurvey

	const handleNavigate = async () => {
		if (employee?.isProfileCompleted) {
			const { search } = window.location
			history.push({
				pathname: '/cuestionario/nom-035/list',
				search,
			})
		}
	}

	const handlePrevious = async () => {
		const { token } = await getParams()
		history.push({
			pathname: '/cuestionario/nom-035',
			search: `?token=${token}`,
		})
	}

	const campaigns = campaignAnswerSessions ?? []

	const getStatus = (index: number) => {
		const cardItem = campaignAnswerSessions[index]
		const previousCardItem = campaignAnswerSessions[index - 1]

		if (cardItem.dateCompleted) return 'done'

		if (!previousCardItem && !cardItem.dateCompleted) return 'opened'

		if (
			previousCardItem &&
			previousCardItem.dateCompleted &&
			!cardItem.dateCompleted
		) {
			return 'opened'
		}

		return 'locked'
	}

	const hasFormToFill = () => {
		const hasForm = campaignAnswerSessions.some(
			(item: any) => !item.dateCompleted,
		)

		return hasForm
	}

	const handleNext = () => {
		const { id } = campaignAnswerSessions.find(
			(item: any) => !item.dateCompleted,
		)

		if (id) {
			const { search } = window.location
			history.push({
				pathname: '/cuestionario/nom-035/list/form',
				search: search.concat(`&id=${id}`),
			})
		}
	}

	return {
		campaign,
		campaigns,
		isGlobalLoading,
		setGlobalLoading,
		isCampaignExpired,
		setGlobalError,
		hasGlobalError,
		companySurvey,
		setCompanySurvey,
		surveyTip,
		showPrivacySettings,
		hasFormToFill,
		setSurveyTip,
		handleNext,
		handlePrevious,
		history,
		handleNavigate,
		getStatus,
	}
}
